import {
    CHAT_GET_CONTACTS,
    CHAT_CHANGE_CONVERSATION,
    USER_FROM_REQUESTS,
    CHAT_GET_CONVERSATIONS,
    CHAT_DELETE_MESSAGE,
    SET_MESSAGES_COUNT,
    SET_CHATS_COUNT,
    SET_CHATS_Filter,
    SET_COMPLAINTS_COUNT
} from '../actions';

export const setChatsFilter = (data) => ({
    type: SET_CHATS_Filter,
    payload: data
})
export const getContacts = (data) => ({
    type: CHAT_GET_CONTACTS,
    payload: data
})
export const getChatMessages = (data) => ({
    type: CHAT_GET_CONVERSATIONS,
    payload: data
})
export const setMessagesCount = (data) => ({
    type: SET_MESSAGES_COUNT,
    payload: data
})

export const setChatsCount = (data) => ({
    type: SET_CHATS_COUNT,
    payload: data
})

// Rated Orders: open low-rating complaints (lives next to the chat counts the sidebar already reads)
export const setComplaintsCount = (data) => ({
    type: SET_COMPLAINTS_COUNT,
    payload: data
})

export const deleteChatMessage = (data) => ({
    type: CHAT_DELETE_MESSAGE,
    payload: data
})


export const setSelectedUser = (data) => ({
    type: CHAT_CHANGE_CONVERSATION,
    payload: data
});

export const setUserFromRequests = (data) => ({
    type: USER_FROM_REQUESTS,
    payload: data
});

